import { Helmet } from "react-helmet-async"
import { HotelsList } from "../../../../Hotels"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function OrganizationHotelsPage() {
	return (
		<>
			<Helmet>
				<title>Hotels | Org</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTELS}>
				<HotelsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
